import * as z from 'zod';

import { inventoryKitQuerySchema } from './inventory-kits-query-schema';

export const inventoryKitUpdateSchema = inventoryKitQuerySchema
  .omit({
    logo: true,
    inventory_kit_items: true,
    category: true,
  })
  .extend({
    logo: z.array(z.number()),
  });

export type InventoryKitUpdateSchema = z.infer<typeof inventoryKitUpdateSchema>;

export const inventoryKitCreateSchema = inventoryKitUpdateSchema.omit({
  id: true,
  logo: true,
});

export type InventoryKitCreateSchema = z.infer<typeof inventoryKitCreateSchema>;
